module.exports = __webpack_public_path__ + "static/desktop/img/mastercard-curved-128px.78722bba.png";